<template>
  <v-list three-line>
    <div v-for="(user, index) in users" :key="index">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title>{{ user.lastName }}, {{ user.firstName }}</v-list-item-title>
          <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{ user.company.name }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="canInviteUser">
          <v-btn @click="resendUserInvite(user._id)" color="primary">Re-send Invite</v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index + 1 < users.length" />
    </div>
    <v-list-item v-if="!users.length">
      <v-list-item-content>
        <v-list-item-title>There are no pending users.</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { hasPermission } from "@/modules/rbac/permission-manifest";
import CompanyService from "@/services/companies/company.service";
export default {
  name: "PendingUsers",
  inject: ["snackBar", "reactiveInjected"],
  props: {
    users: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      canInviteUser: hasPermission(
        "canInviteUser",
        null,
        this.reactiveInjected.activeUser
      ),
      companyService: new CompanyService(),
    };
  },
  methods: {
    resendUserInvite(userId) {
      this.companyService
        .resendUserInvite(userId)
        .then(() => {
          this.snackBar("User has been reinvited", "success");
        })
        .catch((error) => {
          console.error(`Error resending user invite: ${error}`);
          this.snackBar("Something went wrong. Please try again.", "error");
        });
    },
  },
};
</script>

<style scoped></style>
